'use client';

import Link from 'next/link';
import { useAuthCheck } from '@/hooks/useAuthCheck';
import { trackEvent } from '@/lib/analytics/events';

interface AuthAwareCTALinkProps {
  id?: string;
  className?: string;
  ctaName?: string;
  ctaLocation?: string;
  children: React.ReactNode;
}

export function AuthAwareCTALink({
  id,
  className,
  ctaName = 'start_building',
  ctaLocation = 'marketing_cta',
  children,
}: AuthAwareCTALinkProps) {
  const { isAuthenticated, dashboardUrl, signUpUrl } = useAuthCheck();
  const targetHref = isAuthenticated ? dashboardUrl : signUpUrl;

  const handleClick = () => {
    trackEvent('cta_click', {
      cta_name: ctaName,
      cta_location: ctaLocation,
      destination: targetHref,
    });

    if (!isAuthenticated) {
      trackEvent('signup_started', {
        source: ctaLocation,
      });
    }
  };

  return (
    <Link
      href={targetHref}
      prefetch={false}
      id={id}
      className={className}
      onClick={handleClick}
    >
      {children}
    </Link>
  );
}
